export default "__VITE_ASSET__CnhuTzrL__"